<!--
 * @Description:
 * @Autor: tanglitong
 * @Date: 2020-02-03 14:46:45
 * @LastEditors: tanglitong
 * @LastEditTime: 2020-05-14 10:59:53
 -->
<template>
  <div class="symc_right">
    <div class="symcr_live"><a href="https://zb.yiboshi.com/Account/Login" target="_blank"> <img src="../assets/img/live_img.jpg" alt="点击进入十堰继教直播平台" width="230" height="67"></a></div>
    <div class="symcr_notice">
      <div class="symcr_notice_title">最新通知</div>
      <div class="symcr_notice_main">
        <ul style="height: 231px;">
          <marquee  direction="up" scrolldelay="150" scrollamount="1"  style="height: 218px;">
            <li v-for="(item,index) in jxjytzggList" :key="item.id"  >
              <router-link target="_blank" :to="{ path: '/newsInfo', query: { id: item.id }}" :title="item.newsTitle">{{item.newsTitle}}</router-link>
            </li>
          </marquee>
        </ul>
      </div>
    </div>
    <div class="symcr_quick">
      <ul>
        <li><a href="http://cmegsb.cma.org.cn/" target="_blank"> <img src="../assets/img/right_pic_01.jpg" alt="国家级CME项目网上申报及信息反馈系统" width="225" height="75"></a></li>
        <li><a href="http://www.hbma.org.cn/ma/login.asp" target="_blank"> <img src="../assets/img/right_pic_011.jpg" alt="武汉CME项目网上申报，申报，审批，公布系统" width="225" height="75"></a></li>
        <el-tooltip content=" 敬请期待 " placement="top">
        <li><a href="javascript:;"  target="_blank"> <img src="../assets/img/right_pic_02.jpg" alt="市级CME项目网上申报及信息反馈系统" width="225" height="75"></a></li>
        </el-tooltip>
          <!--<li><a href="http://www.91huayi.com" target="_blank"> <img src="../assets/img/right_pic_901.jpg" alt="国家级远程学分教育" width="225" height="75"> </a></li>-->
        <!--<el-tooltip content=" 敬请期待 " placement="top">-->
        <li><a href="http://kjpt.91huayi.com/"  target="_blank"> <img src="../assets/img/right_pic_04.jpg" alt="科教管理平台单位版" width="225" height="75"></a></li>
        <!--</el-tooltip>-->
        <!--<el-tooltip content=" 敬请期待 " placement="top">-->
        <li><a href="http://kjptwsw.91huayi.com"  target="_blank"> <img src="../assets/img/right_pic_05.jpg" alt="科教管理平台学员版" width="225" height="75"></a></li>
        <!--</el-tooltip>-->

        <li><a :href="TEACH_ADMIN_URL" target="_blank"> <img src="../assets/img/right_pic_061.jpg" alt="市级学分平台管理员入口" width="225" height="75"></a></li>
      </ul>
    </div>
  </div>
</template>

<script>
  import {listNews} from '../api/api';

    export default {
        components: {

        },
        data () {
            return {
              jxjytzggList:[],
              TEACH_ADMIN_URL:process.env.TEACH_ADMIN_URL
            }
        },

        mounted () {
          /*继续教育--通知公告*/
          listNews({
            consultId: 56,
            publishState: 0,
            publishTime: this.$moment().format('YYYY-MM-DD HH:mm:ss'),
            'displayPositionIds': [1, 3],
            'notProjectIds': [8, 9],
            'orderWeight': true,
            orderPublishTime: true,
            pageNum: 1,
            pageSize: 5
          }).then((response) => {
            this.jxjytzggList = response.data.data.list;
          });
        },
        methods: {
          jqqd(){

          }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/LatestNewsSimple.vue